export default __webpack_public_path__ + "static/media/new-icon-health-info.a80b06fc.svg";